// src/utils/config.js
class ConfigManager {
  constructor() {
    this.config = window.APP_CONFIG || {};
    this.init();
  }

  init() {
    // 设置默认值
    this.config = {
      //API_BASE_URL: 'http://localhost:8000',
      //API_BASE_URL: 'http://110.40.192.49',
      API_BASE_URL: 'http://www.pdb.asia',
      APP_NAME: '报价管理系统',
      VERSION: '1.0.0',
      PAGE_SIZE: 10,
      MAX_FILE_SIZE: 10 * 1024 * 1024,
      UPLOAD_TIMEOUT: 30000,
      ...this.config
    };
  }

  // 获取配置项
  get(key, defaultValue = null) {
    return this.config[key] !== undefined ? this.config[key] : defaultValue;
  }

  // 设置配置项（运行时修改）
  set(key, value) {
    this.config[key] = value;
  }

  // 获取所有配置
  getAll() {
    return { ...this.config };
  }

  // 重新加载配置（从服务器）
  async reload() {
    try {
      // 在 Vue CLI 中，使用 process.env.BASE_URL 获取基础路径
      const baseUrl = process.env.BASE_URL || '/';
      const response = await fetch(`${baseUrl}config.js?t=${Date.now()}`);
      const configText = await response.text();
      
      // 解析配置
      const configMatch = configText.match(/window\.APP_CONFIG\s*=\s*({[^}]+})/);
      if (configMatch) {
        const newConfig = eval('(' + configMatch[1] + ')');
        this.config = { ...this.config, ...newConfig };
        return true;
      }
    } catch (error) {
      console.warn('重新加载配置失败:', error);
    }
    return false;
  }
}

// 创建全局配置实例
const configManager = new ConfigManager();

export default configManager;